import { useState } from "react";

export default function usePagination(data: any[], rowsPerPage: number) {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(data.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(p => p + 1);
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(p => p - 1);
    };

    const goToPage = (page: number) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    return { currentPage, totalPages, currentRows, handleNextPage, handlePreviousPage, goToPage, setCurrentPage };
}
